import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Button from "../form/Button";
import { classNames } from "../../helpers/classNames";
import { ShareButtons } from "../../util/Flag";
import { useSelector } from "react-redux";

const OrganizerEventCard = ({
  event,
  addToFavorite = () => {},
  layoutStyle = "grid", // grid || list
}) => {
  const { lang } = useSelector((state) => state?.langProvider);

  return (
    <Link to={`/${lang}${event?.link}` || "#"}>
      {layoutStyle === "grid" && (
        <div className="rounded-xl border border-slate-200 bg-white shadow flex flex-col h-full hover:shadow-xl hover:shadow-purple-100 hover:border-primary/10 transition-all duration-300">
          <div className="relative aspect-[6/4]">
            {event?.image?.length > 0 ? (
              event?.image?.length > 1 ? (
                <img
                  src={event?.image[0]}
                  alt={event?.eventTitle}
                  className="w-full h-full object-cover rounded-t-xl"
                />
              ) : (
                <img
                  src={event?.image}
                  alt={event?.eventTitle}
                  className="w-full h-full object-cover rounded-t-xl"
                />
              )
            ) : (
              <div className="w-full aspect-[7/5] bg-slate-100"></div>
            )}
            <span
              className={`absolute top-3 left-3 px-3 py-1 text-xs font-semibold text-white rounded-full ${
                event?.locationStatus === "online"
                  ? "bg-pink-600"
                  : "bg-purple-600"
              }`}
            >
              {event?.locationStatus}
            </span>
            <div className="absolute top-3 right-3 flex gap-2">
              <Button
                buttonClasses={classNames(
                  "bg-white/40 p-2 rounded-md shadow hover:bg-white/40 flex-shrink-0 w-8 2xl:w-10 h-8 2xl:h-10 flex items-center justify-center !text-white backdrop-blur-sm transition"
                )}
                buttonIcon={
                  event?.isWishlist
                    ? "fa-solid fa-heart text-gradient-red"
                    : "fa-light fa-heart"
                }
                buttonIconPosition="left"
                buttonLabelClasses={"!text-white"}
                buttonIconClass={"!text-sm 2xl:!text-xl"}
                buttonFunction={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  addToFavorite(event);
                }}
              />
              <ShareButtons
                url={`${window.location?.origin}${event?.link}`}
                text="Join this amazing event:-"
                buttonIcon={"fa-light fa-share-nodes"}
                buttonClass={
                  "bg-white/40 p-2 rounded-md shadow hover:bg-white/40 flex-shrink-0 w-8 2xl:w-10 h-8 2xl:h-10 flex items-center justify-center !text-white backdrop-blur-sm transition"
                }
                buttonIconClass={"!text-sm 2xl:!text-xl"}
              />
            </div>
          </div>
          <div className="p-3 2xl:p-6 space-y-3">
            {event?.eventTitle && (
              <h4 className="text-base 2xl:text-lg font-semibold capitalize text-purple-900 mb-5 2xl:mb-3">
                {event?.eventTitle}
              </h4>
            )}
            {event?.date && (
              <div className="text-sm 2xl:text-base text-gray-600 flex items-center gap-2 font-medium">
                <span className="bg-white w-8 h-8 text-sm border border-slate-300 flex items-center justify-center rounded-md flex-shrink-0">
                  <i className="fa-light fa-calendar-days"></i>
                </span>{" "}
                {event?.date}
              </div>
            )}

            {event?.location && (
              <div className="text-sm 2xl:text-base text-gray-600 flex items-center gap-2 font-medium">
                <span className="bg-white w-8 h-8 text-sm border border-slate-300 flex items-center justify-center rounded-md flex-shrink-0">
                  <i className="fa-light fa-location-dot"></i>
                </span>{" "}
                {event?.location}
              </div>
            )}
            {event?.participants > 0 && (
              <div className="text-sm 2xl:text-base text-gray-600 flex items-center gap-2 font-medium">
                <span className="bg-white w-8 h-8 text-sm border border-slate-300 flex items-center justify-center rounded-md flex-shrink-0">
                  <i className="fa-light fa-users"></i>
                </span>{" "}
                {event?.participants} participant
                {event?.participants > 1 ? "s" : ""}
              </div>
            )}
            {/* <div className="flex justify-between items-center pt-3 border-t mt-3">
          <span className="text-sm text-gray-500">Organizer</span>
          <button className="text-sm px-3 py-1 border border-primary rounded-md hover:bg-primary hover:text-white transition">
            Manage Event
          </button>
        </div> */}
          </div>
        </div>
      )}
      {layoutStyle === "list" && (
        <div className="rounded-xl border border-slate-200 bg-white shadow flex h-full overflow-hidden hover:shadow-xl hover:shadow-primary/10 hover:border-primary/10 transition-all duration-300 p-3 w-full">
          <div className="w-1/3">
            <div className="relative aspect-[6/4] overflow-hidden rounded-md">
              {event?.image?.length > 0 ? (
                <img
                  src={
                    Array.isArray(event.image) ? event.image[0] : event.image
                  }
                  alt={event?.eventTitle}
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="w-full aspect-[7/5] bg-slate-100"></div>
              )}
              <span
                className={`absolute top-3 left-3 px-3 py-1 text-xs font-semibold text-white rounded-full ${
                  event?.locationStatus === "online"
                    ? "bg-pink-600"
                    : "bg-purple-600"
                }`}
              >
                {event?.locationStatus}
              </span>

              <div className="absolute top-3 right-3 flex gap-2">
                <Button
                  buttonClasses={classNames(
                    "bg-white/40 p-2 rounded-md shadow hover:bg-white/40 flex-shrink-0 w-10 h-10 flex items-center justify-center !text-white backdrop-blur-sm transition"
                  )}
                  buttonIcon={
                    event?.isWishlist
                      ? "fa-solid fa-heart text-gradient-red"
                      : "fa-light fa-heart"
                  }
                  buttonIconPosition="left"
                  buttonLabelClasses={"!text-white"}
                  buttonFunction={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    addToFavorite(event);
                  }}
                />
                <ShareButtons
                  url={`${window.location?.origin}${event?.link}`}
                  text="Join this amazing event:-"
                  buttonIcon={"fa-light fa-share-nodes"}
                  buttonClass={
                    "bg-white/40 p-2 rounded-md shadow hover:bg-white/40 flex-shrink-0 w-10 h-10 flex items-center justify-center !text-white backdrop-blur-sm transition"
                  }
                  buttonIconClass={"!text-sm 2xl:!text-xl"}
                />
              </div>
            </div>
          </div>

          <div className="w-2/3 px-6 py-4">
            <ul className="space-y-3">
              {event?.eventTitle && (
                <li className="text-lg font-semibold capitalize text-purple-900 mb-2">
                  {event.eventTitle}
                </li>
              )}

              {event?.date && (
                <li className="flex items-center gap-2 text-gray-600 font-medium">
                  <span className="bg-white w-8 h-8 text-sm border border-slate-300 flex items-center justify-center rounded-md">
                    <i className="fa-light fa-calendar-days"></i>
                  </span>
                  {event.date}
                </li>
              )}

              {event?.location && (
                <li className="flex items-center gap-2 text-gray-600 font-medium">
                  <span className="bg-white w-8 h-8 text-sm border border-slate-300 flex items-center justify-center rounded-md">
                    <i className="fa-light fa-location-dot"></i>
                  </span>
                  {event.location}
                </li>
              )}

              {event?.participants > 0 && (
                <li className="flex items-center gap-2 text-gray-600 font-medium">
                  <span className="bg-white w-8 h-8 text-sm border border-slate-300 flex items-center justify-center rounded-md">
                    <i className="fa-light fa-users"></i>
                  </span>
                  {event.participants} participant
                  {event.participants > 1 ? "s" : ""}
                </li>
              )}
            </ul>
          </div>
        </div>
      )}
    </Link>
  );
};

export default OrganizerEventCard;
